// extracted by mini-css-extract-plugin
export default {"thinkingDot":"ResponseThinkingPlaceholder_thinkingDot__Yi8bD"};